let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eSWeE")).then(() => parcelRequire('kLWhg'));